import React, { useState } from "react";
import Heading3 from "../Font/Heading4";
import Heading7 from "../Font/Heading7";
import Price from "../Font/Price";
import Text3 from "../Font/Text3";
import rating_star from "./../../assets/Icon/rating_star.svg";
import "./../../SCSS/MostSharedComponents/_myOrderProduct.scss";
import Protection from "./Protection";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { titleChange } from "../helpers/utils/titleNameChange";

function MyOrderProduct(props) {
  const { product } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const redirectOrderDetailPage = (orderId) => {
    navigate(`/user/orders/${orderId}`);
  }

  return (
    <div className="row mo__product__block">
      <div className="col-12 col-sm-2 mo__product__left__block">
        <div className="mo__product__image__block">
          <img src={product.logo} alt="" className="mo__product__image" />
        </div>
      </div>
      <div className="col-12 col-sm-7 mo__product__middle__block">
        <Heading3 text={titleChange(product.name)} marginBottom={10} />
        <div className="row mo__order__details__row">
          <div className="col-4 col-sm-4 col-md-2">
            <Heading7 text={t('SKU')} color="#727272" span={true} />
          </div>
          <div className="col-8 col-sm-8 col-md-4">
            <Text3 text={product.sku} span={true} />
          </div>
          <div className="col-4 col-sm-4 col-md-2">
            <Heading7 text={`${t("Order_Placed:")}:`} color="#727272" span={true} />
          </div>
          <div className="col-8 col-sm-8 col-md-4">
            <Text3 text={product.orderPlaced} span={true} />
          </div>
        </div>
        <div className="row mo__order__details__row">
          <div className="col-4 col-sm-4 col-md-2">
            <Heading7 text={`${t("ORDER_#")}:`} color="#727272" span={true} />
          </div>
          <div className="col-8 col-sm-8 col-md-4">
            <Text3 text={product.orderId} span={true} />
          </div>
          <div className="col-4 col-sm-4 col-md-2">
            <Heading7 text={`${t("Total_Amount")}:`} color="#727272" span={true} />
          </div>
          <div className="col-8 col-sm-8 col-md-4">
            <Price price={product.totalAmount} currency={product.currency} span={true} size="heading6" />
          </div>
        </div>

        <Protection
          title="Protection Plan"
          tagline="Most popular protection plan for your product"
          rating={product.rating}
          totalRatings={product.totalRatings}
          protection={product.protection}
        />
      </div>
      <div className="col-12 col-sm-3 mo__product__right__block">
        <button onClick={() => redirectOrderDetailPage(product.orderId)} className="mo__order__detail__button">{t("ORDER_DETAIL")}</button>
        {/* <div>
          <img src={rating_star} alt="" />
          <Link className="write_Review__link" to="#">
            {t("Write_review_of_this_product")}
          </Link>
        </div> */}
      </div>
    </div>
  );
}

export default MyOrderProduct;
